module.exports = __webpack_public_path__ + "static/media/MS.544ff80c.jpg";